import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import {
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
  resetPasswordWithTokenDialogSetIsLoadingReducerType,
  resetPasswordWithTokenDialogSetNewPasswordReducerType,
} from './ResetPasswordWithTokenDialogConstants';

export const initialState = Map({
  isLoading: false,
  newPassword: {
    value: '',
    isValid: true,
    errors: [],
    dirty: false,
  },
  confirmationPassword: {
    value: '',
    isValid: true,
    errors: [],
    dirty: false,
  },
});

const spec = {
  [resetPasswordWithTokenDialogSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [resetPasswordWithTokenDialogSetNewPasswordReducerType]: (state, action) => {
    const { newPassword } = action.payload;
    return state.set('newPassword', newPassword);
  },
  [resetPasswordWithTokenDialogSetConfirmationPasswordReducerType]: (state, action) => {
    const { confirmationPassword } = action.payload;
    return state.set('confirmationPassword', confirmationPassword);
  },
};

export default createReducerBySpec(spec, initialState);
